import { get, post, put, del, publicGet, publicPost } from './_httpClient';

export async function getPreSurveyBumdes({
  page = 1,
  pageSize = 10,
  q = '',
  provinceId = '',
  attendanceStatus = '',
  isWillingToJoin = '',
}) {
  const {
    status: respStatus,
    message,
    data,
  } = await get(
    `/clp/pre-survey?q=${q}&provinceId=${provinceId}&attendanceStatus=${attendanceStatus}&isWillingToJoin=${isWillingToJoin}&page=${page}&pageSize=${pageSize}`,
  );
  if (respStatus !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPreSurveyBumdesStats() {
  const {
    status: respStatus,
    message,
    data,
  } = await get('/clp/pre-survey/stats');
  if (respStatus !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPreSurveyBumdesDetail({ id }) {
  const {
    status: respStatus,
    message,
    data,
  } = await get(`/clp/pre-survey/${id}`);
  if (respStatus !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBumdesOptions({ q = '' }) {
  const { status, message, data } = await publicGet(
    `/clp/bumdes/options?q=${q}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBumdesAutofill({ id }) {
  const { status, message, data } = await publicGet(
    `/clp/bumdes/${id}/autofill`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function submitPreSurveyBumdes({ payload }) {
  return publicPost('/clp/pre-survey/submit', payload);
}

export async function updatePreSurveyBumdes({ payload }) {
  return put('/clp/pre-survey/me', payload);
}

export async function registerBumdes(payload) {
  return publicPost('/program/bumdes/registrations', payload);
}

export async function getBumdesRegistrations() {
  return get('/clp/admin/bumdes/registrations');
}

export async function getBumdesRegistrationDetail(id) {
  return get(`/clp/admin/bumdes/registrations/${id}`);
}

export async function approveBumdesRegistration(id, payload) {
  return put(`/clp/admin/bumdes/registrations/${id}/approve`, payload);
}

export async function rejectBumdesRegistration(id, payload) {
  return put(`/clp/admin/bumdes/registrations/${id}/reject`, payload);
}

export async function getBumdesList() {
  return get('/clp/admin/bumdes');
}

export async function getBumdesDetail(id) {
  return get(`/clp/admin/bumdes/${id}`);
}

export async function deleteBumdes(id, { isForce = false } = {}) {
  const query = isForce ? '?isForce=true' : '';
  const { status, message, canForce } = await del(`/clp/admin/bumdes/${id}${query}`);
  if (status !== 'success') {
    const error = new Error(message);
    error.canForce = canForce;
    throw error;
  }
  return message;
}

export async function getBUMDesAwardWinners({ batchId }) {
  return get(`/clp/admin/bumdes-awards/winners?batchId=${batchId}`);
}

export async function getBUMDesAwardRankings({ batchId }) {
  return get(`/clp/admin/bumdes-awards/rankings?batchId=${batchId}`);
}

export async function recalculateBUMDesAwardWinners({ batchId }) {
  return post('/clp/admin/bumdes-awards/recalculate', { batchId });
}

export async function getBumdesPreSurveyAutofill() {
  return get('/clp/pre-survey/autofill');
}
